// Measured geometry of the generated checkers board art (checkers_board.webp).
// The source render has a wooden frame around the playable 8×8 area; these
// fractions (of the square image's edge) map board squares to pixels:
//   inner_offset = displaySize * BOARD_INNER_OFFSET_FRAC   (left/top of square 0,0)
//   square       = displaySize * BOARD_INNER_SIZE_FRAC / 8
// Measured 2026-07-09 on the 1254×1254 source: inner box starts at 49px and
// spans 1154px. Dark squares are (row+col) EVEN with (0,0) dark — the same
// convention as the checkers engine, so square (r,c) maps 1:1 with no flip.
export const BOARD_INNER_OFFSET_FRAC = 49 / 1254;   // 0.03908
export const BOARD_INNER_SIZE_FRAC = 1154 / 1254;   // 0.92025

// Texture keys (BoardGameScene's tier 0 — see assetManifest needsFor): board + piece
// sprites per color/rank.
export const CHECKERS_TEXTURES = {
  board: 'checkers_board',
  w: 'checkers_piece_red',      // 'w' = host side = red pieces
  b: 'checkers_piece_brown',
  W: 'checkers_queen_red',
  B: 'checkers_queen_brown',
};
